import React, { Component, Fragment } from "react";
import { PhoneContainer, StepContainer } from "./StyledComponents";
import { EmplacementQuestion, SimulatedSurvey } from "./surveyStep";
import _ from "lodash";
import ConfirmButton from "./../../../buttons/ConfirmButton";

class SurveyStepSimulation extends Component {
	state = {
		survey: {},
	};

	previousJson = {
		surveyAnswers: {},
		surveyData: {},
		visit: {},
		simulationDisplayed: null,
		simulationPosition: "left",
	};

	generateSurvey = survey => {
		//console.log("submit", survey);
		this.props.setGenerated(true);
		//this.setState({ survey});
	};
	render() {
		const {
			current,
			steps,
			prev,
			next,
			sucess,
			disabled,
			currentSurvey,
			isSurveyGenerated,
		} = this.props;
		const { simulationDisplayed, simulationPosition } = this.state;
		const displayIcon = simulationDisplayed ? "icon-deploy" : "icon-reduce";
		//console.log(this.state.survey);
		//console.log(this.state.isSurveyGenerated);

		//let locationTypes = currentSurvey.locationTypes || [];
		return null;
		return (
			<div
				className={`p-survey-simulation-container p-survey-simulation-position-${simulationPosition}`}
			>
				<div className="p-content-item">
					<div className="p-survey-simulation-phone">
						<div className="p-survey-simulation-phone-header">
							<div className="p-al-left p-page-subtitle">Simulation</div>
							<div className="p-al-r-full-center">
								<span
									className="p-survey-simulation-icon icon-arrow-left"
									onClick={() =>
										this.setState({
											simulationPosition: "left",
										})
									}
								/>
								<span
									className="p-survey-simulation-icon icon-arrow-right"
									onClick={() =>
										this.setState({
											simulationPosition: "right",
										})
									}
								/>
								<span
									className={`p-survey-simulation-icon p-survey-simulation-icon-close ${displayIcon}`}
									onClick={() =>
										this.setState({
											simulationDisplayed: simulationDisplayed
												? null
												: "p-hidden",
										})
									}
								/>
							</div>
						</div>
						<div className={`${simulationDisplayed}`}>
							{isSurveyGenerated ? (
								<Fragment>
									<ConfirmButton
										label="Modifier la strate"
										onClick={this.props.resetSimulationPagination}
										classes="p-mrg-bot-s"
									/>
									<SimulatedSurvey />
								</Fragment>
							) : (
								<EmplacementQuestion handleSubmit={this.generateSurvey} />
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default SurveyStepSimulation;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSimulation/SurveyStepSimulation.js